import type { RequestHandler } from '@apollo/client/core';
import { ApolloLink } from '@apollo/client/core';

import { AuthenticationPlugin } from '../../plugin';

function createAuthenticationHandler(authPlugin: AuthenticationPlugin): RequestHandler{

    return (operation, forward) => {

        let session = authPlugin.session
        let token =  session?.token;

        if(token) {

            const currentHeaders = operation.getContext()?.headers;

            if(!currentHeaders || (!currentHeaders['Authorization'] && !currentHeaders['authorization'])){

                operation.setContext({
                    headers: {
                        ...(currentHeaders || {}),
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }

        return forward(operation);
    }
}

export function createAuthenticationLink(authPlugin: AuthenticationPlugin){

    return new ApolloLink(createAuthenticationHandler(authPlugin));
}

export default createAuthenticationLink;